import { IModel, ResultSuccess, Repo, transformFirestoreTypes } from "./Repo";
import {auth, firestore} from '@crema/services/auth/firebase/firebase';
import { AuthType } from "shared/constants/AppEnums";
import { AuthUser } from "../AuthUser";
// import { SpacePermissions, UserSpaceMap } from "../home/HomeApp";
import { DocumentData } from "@firebase/firestore-types";
import { Calendar, CalendarProps, Views } from "react-big-calendar";

// import { Collection, getRepository } from 'fireorm';

// @Collection()
// export class UserModel implements IModel{
    export interface UserModel extends IModel{

    // uid: string;
    // displayName?: string;
    firstName: string;
    lastName: string;
    email: string;
    authType: AuthType;
    photoURL?: string;
    phone?: string;
    sarsId?: string;
    intakeComplete?: boolean;
    fabmanMember?: any;
    prefs?: UserPrefs;
    // memberType: string;
    // memberType:
    permissions?: any[];
    member?: number;
    spaceIds?: string[];
    intakeFields?: string;
    // spacePermissions?: SpacePermissions[];
    // userSpaceMapArray?: UserSpaceMap[];
    // spaceMap?: Map<string, SpacePermissions>;
    // role: string[];

}

export type UserPrefs = {
    defaultCalendarView?: typeof Views;
}

export class UserRepo extends Repo<UserModel> {

    // mapDbToObject(docData: DocumentData, id: string): UserModel {


    //
    //     let tt = transformFirestoreTypes(docData) as UserModel;

    //

    //     Object.keys(tt).forEach(key => {
    //         const val = docData[key];
    //
    //     }        );

    //     let userModel: UserModel = {
    //         id: id,
    //         email: docData.email,
    //         firstName: docData.firstName,
    //         lastName: docData.lastName,
    //         organization: docData.organization,
    //         authType: AuthType.FIREBASE,
    //         createdOn: new Date(docData.createdOn.seconds * 1000),
    //         createdBy: docData.createdBy,
    //         lastUpdatedOn: new Date(docData.lastUpdatedOn.seconds * 1000),
    //         lastUpdatedBy: docData.createdBy,
    //         spaceMap: docData.spaceMap
    //     } //Object.assign({}, dbObject) as UserModel;


    //     userModel.id = id;
    //     userModel.createdOn = new Date(
    //       docData.createdOn?.seconds * 1000,
    //     )
    //     userModel.lastUpdatedOn = new Date(
    //       docData.lastUpdatedOn?.seconds * 1000,
    //     )
    //     return userModel;

    // }

    // dbPath = "users/dbid";

    getDbPath(id: string){


        return `/users/${id}`;
    }

    // create(object: AuthUserModel): ResultSuccess<AuthUserModel> {
    //     let user = firestore.doc(User.getDbPath(object.id)).set(object).then(() => {return object}).catch();

    // }//implements AuthUserModel {


    // static create(obj: AuthUserModel): ResultSuccess<AuthUserModel> {
    //     let user = firestore.doc(this.dbPath).set(this).then(() => {return this}).catch();

    // }
    // update(object: AuthUserModel): void | ResultSuccess<AuthUserModel> {
    //     throw new Error("Method not implemented.");
    // }
    // get(id: string): AuthUserModel {
    //     throw new Error("Method not implemented.");
    // }
    // delete(idOrObject: string | AuthUserModel): AuthUserModel {
    //     throw new Error("Method not implemented.");
    // }
    // firstName: string;
    // lastName: string;
    // email: string;
    // authType: AuthType;
    // photoURL?: string | undefined;
    // phone?: string | undefined;
    // organization?: string | undefined;

    // construtor(input: AuthUserModel){
    // }

    // dbPath = `/users/${this.id}`;

    // static createUser(user: AuthUserModel, id: string): void{
    //     user.id = id;
    //     user.dbPath = `/users/${user.id}`;

    //     firestore.doc(this.dbPath).set(createUserFields).then(() => )


    // }

    // create(user: AuthUserModel): ResultSuccess<AuthUserModel> {

    //     try {
    //         auth
    //           .createUserWithEmailAndPassword(user.email, password)
    //           .then((data: any) => {
    //             let user: AuthUserModel = {
    //               id: data.id,
    //               email: data.email,
    //               firstName: data.firstName,
    //               lastName: data.lastName,
    //               organization: data.organization,
    //               authType: AuthType.FIREBASE,
    //               createdOn: new Date(),
    //               createdBy: data.id,
    //               lastUpdatedOn: new Date(),
    //               lastUpdatedBy: data.id
    //             }


    //             dispatch(fetchSuccess());
    //             dispatch({type: UPDATE_AUTH_USER, payload: });
    //           })
    //           .catch(error => {
    //             dispatch(fetchError(error.message));
    //           });
    //       } catch (error) {
    //         dispatch(fetchError(error.message));
    //       }
    //     };




    //     // this.
    //     // // auth
    //     // // .createUserWithEmailAndPassword(this.email, this.password)
    //     // // .then(data => {});
    //     // return new ResultSuccess({id: "sfd"}, null);
    //     throw new Error("Method not implemented.");
    // }


}